import React from 'react';
import moment from 'moment';
import type { Project } from '../../models/projects/project';
import { STATUS } from '../../models/projects/project';
import { delimited } from '../../../common/utils/commonUtil';

type Props = {
  project: Project;
};

export default function CardAchievement(props: Props) {
  const { project } = props;

  if (
    (project.status === STATUS.inProgress &&
      moment().isAfter(moment(project.startAt)) &&
      project.productsSize > 0) ||
    project.waitingWaitOrder
  ) {
    return (
      <div className="achievement clearfix">
        <div className="float-right">
          <span className="solicit">{delimited(project.solicited)}円</span> /{' '}
          {delimited(project.solicit)}円
        </div>
      </div>
    );
  } else if (
    project.status === STATUS.succeeded ||
    project.status === STATUS.executed
  ) {
    return (
      <div className="achievement clearfix">
        <div className="float-right">
          <span className="solicit">
            {delimited(
              project.delivPrice != null
                ? project.delivPrice
                : project.solicited,
            )}
            円{' '}
          </span>
          / {delimited(project.solicit)}円
        </div>
      </div>
    );
  } else if (
    project.status !== STATUS.failed &&
    (moment(project.startAt).isAfter(moment()) || project.productsSize === 0)
  ) {
    return (
      <div className="achievement clearfix">
        <div className="text-center">
          <span className="before-in-progress">案件事前開示中</span>
        </div>
      </div>
    );
  } else {
    return <div className="achievement" />;
  }
}
